import { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import { RoiForm } from "./roiForm";
import api from "../api/api";
import stringHelpers from "../../utilities/stringHelpers";

export default function AddCameraRoi(props) {
    const history = useHistory();

    const { siteId, cameraId } = useParams();
    const [image, setImage] = useState(null);
    const [points, setPoints] = useState([]);
    const [roiName, setRoiName] = useState("");
    const [polygon, setPolygon] = useState("");
    const [ratio, setRatio] = useState(null);
    const [imageUrl, setImageUrl] = useState(null);

    const handleMouseDown = (event) => {
        const rect = event.target.getBoundingClientRect();
        const x = event.clientX - rect.left;
        const y = event.clientY - rect.top;
        setPoints((prevPoints) => [...prevPoints, { x: x / ratio, y: y / ratio }]);
    };

    const handleSave = () => {
        const payloadString = `POLYGON((${points.reduce((acc, curr) => {
            acc += `${ curr.x } ${ curr.y }, `
            return acc
        }, "")}${ points[0].x } ${ points[0].y }))`
        api.addCameraRoi(
            props.organisationId, cameraId, roiName, payloadString,
            () => history.push(`/organisation/${ props.organisationId }/site/${ siteId }/camera/${ cameraId }`),
            error => console.log(error),
            props.token
        )
    }

    useEffect(() => {
        api.getCamera(
            result => setImageUrl(result.imageUrl),
            error => console.log(error),
            props.organisationId,
            cameraId,
            props.token
        )
    }, [])

    useEffect(() => {
        if (!stringHelpers.isNullOrEmpty(imageUrl)) {
            const _image = new Image();
            _image.src = imageUrl;
            setImage(_image)
            _image.onload = () => {

                const container = document.querySelector(".edit-image-container");
                if (container) {
                    const _ratio = container.clientWidth / _image.naturalWidth;
                    setRatio(_ratio)
                }
            }

            window.addEventListener("resize", () => {
                if (_image) {
                    const container = document.querySelector(".edit-image-container");
                    if (container) {
                        const _ratio = container.clientWidth / _image.naturalWidth;
                        setRatio(_ratio)
                    }
                }
            })
        }
    }, [imageUrl])
    
    return image && <RoiForm
        title="Add Region of Interest"
        onCancel={ () => history.push(`/organisation/${ props.organisationId }/site/${ siteId }/camera/${ cameraId }`) }
        onSave={ handleSave }
        roiName={ roiName }
        polygon={ polygon }
        setPolygon={ setPolygon }
        setName={ setRoiName }
        imageSource={image.src}
        handleImageClick={e => handleMouseDown(e)}
        points={points}
        setPoints={setPoints}
        ratio={ratio}
    />
}